import moment from 'moment';

import { ActionType, getType } from 'typesafe-actions';

import { BusinessDayConventionTypes } from '../../../../../../models/BusinessDayConvention/enum';
import { DayCountTypes } from '../../../../../../models/DayCountType/enums';
import { HedgingInstrumentInterestRateMode } from '../../../../../../models/HedgingInstrument/enum';
import { MasterLeg } from '../../../../../../models/MasterLeg';
import { PayFrequencyTypes } from '../../../../../../models/PayFrequency/enum';

import * as pricerActions from './../../actions';
import { empty_master_leg_terms } from './constants';

type PricerActionType = ActionType<typeof pricerActions>;

export type MasterLegState = MasterLeg;

export const MasterLegInitialState: MasterLeg = empty_master_leg_terms;

const masterLegReducer = (
  state: MasterLeg = MasterLegInitialState,
  action: PricerActionType,
): MasterLeg => {
  switch (action.type) {
    case getType(pricerActions.populateTradeDefault): {
      /*const defaultIndexId = getDefaultForecastingIndexFromCurrencyConventions(
        action.payload.user_currency_id,
        action.payload.currency_conventions,
      );*/
      const maturityDate = moment(action.payload.market_date)
        .add(10, 'y')
        .format('YYYY-MM-DD');
      const inflationBaseDate = moment(action.payload.market_date)
        .add(-1, 'm')
        .format('YYYY-MM-DD');

      const calculationCalendarFiltered = action.payload.currencies.filter(
        (el) => el.currency_id == action.payload.user_currency_id,
      );
      const calculationCalendarId = calculationCalendarFiltered[0]
        ? calculationCalendarFiltered[0].default_calendar_pmca_id
        : null;

      /*const toggle_commodity_master_leg_inputs =
        action.payload.instrument_type_id ==
        HedgingInstrumentInterestRateMode.commoditySwap;
      const commodity_index =
        action.payload.instrument_type_id ==
        HedgingInstrumentInterestRateMode.commoditySwap
          ? 10
          : null;*/
      const notional_value =
        action.payload.instrument_type_id ==
        HedgingInstrumentInterestRateMode.commoditySwap
          ? 500
          : 100000000;

      return {
        ...state,
        notional: notional_value,
        currency_id: action.payload.user_currency_id,
        collateral_currency: action.payload.user_currency_id,
        //discounting_index_id: defaultIndexId,
        day_count_id: DayCountTypes.act360,
        initial_notional_exchange: false,
        intermediary_notional_exchange: false,
        final_notional_exchange: false,
        // Dates
        effective_date: action.payload.market_date,
        maturity_date: maturityDate,
        settlement_date: null,
        pay_frequency: PayFrequencyTypes.quarterly,
        //pay_start_end: PaymentTypes.end,
        payment_offset: 0,
        business_day_convention: BusinessDayConventionTypes.modifiedFollowing,
        calendar_currencies: [action.payload.user_currency_id],
        inflation_base_date: inflationBaseDate,

        // date roll fields
        toggle_roll_fields_flag: false,
        eom_roll: true,
        first_payment_date: null,
        next_to_last_payment_date: null,
        calculation_calendar: calculationCalendarId
          ? [calculationCalendarId]
          : null,
      };
    }
    default:
      return state;
  }
};

export default masterLegReducer;
